// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;Teach me your way, O Lord, and I will walk in your truth;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;knit my heart to you, that I may fear your name.<br> </p> </div></div>";
// Exports
module.exports = code;